import { render, staticRenderFns } from "./Disparadores.vue?vue&type=template&id=63804616"
import script from "./Disparadores.vue?vue&type=script&lang=js"
export * from "./Disparadores.vue?vue&type=script&lang=js"
import style0 from "./Disparadores.vue?vue&type=style&index=0&id=63804616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports